module.exports = __webpack_public_path__ + "static/img/sprite2310.869fb67.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/sprite2310.png
// module id = 46Qi
// module chunks = 7